import { Bell, Menu } from 'lucide-react'
import { useAuth } from '../../hooks/useAuth'

export default function Header({ onMenuClick }) {
  const { user } = useAuth()

  return (
    <header className="sticky top-0 z-30 bg-white border-b border-gray-200">
      <div className="flex items-center justify-between px-6 py-4">
        {/* Menu hambúrguer (mobile) */}
        <button
          onClick={onMenuClick}
          className="lg:hidden p-2 text-gray-600 hover:bg-gray-100 rounded-lg"
        >
          <Menu className="w-6 h-6" />
        </button>

        {/* Espaço flex */}
        <div className="flex-1" />

        {/* Ações do header */}
        <div className="flex items-center gap-4">
          {/* Notificações */}
          <button className="p-2 text-gray-600 hover:bg-gray-100 rounded-lg relative">
            <Bell className="w-5 h-5" />
            {/* Badge de notificação */}
            <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
          </button>

          {/* Avatar do usuário */}
          <div className="hidden sm:flex items-center gap-3">
            <div className="w-9 h-9 bg-primary-100 rounded-full flex items-center justify-center">
              <span className="text-primary-700 font-medium text-sm">
                {user?.name?.charAt(0).toUpperCase() || 'U'}
              </span>
            </div>
            <span className="text-sm font-medium text-gray-700">
              {user?.name?.split(' ')[0]}
            </span>
          </div>
        </div>
      </div>
    </header>
  )
}
